import { UserLoginOrRegistrationRequest, UserLoginOrRegistrationResponse } from '../../types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

// 백엔드에 사용자 정보 전송
export const sendUserToBackend = async (request: UserLoginOrRegistrationRequest): Promise<UserLoginOrRegistrationResponse> => {
  try {
    let body = {
      provider: request.provider,
      provider_id: request.id,
      name: request.name,
      email: request.email,
      picture: request.picture,
      accessToken: request.accessToken
    }

    if ((request as any).phone_number) {
      (body as any).phone_number = (request as any).phone_number;
    }

    if ((request as any).phone_number_verified) {
      (body as any).phone_number_verified = (request as any).phone_number_verified;
    }

    if ((request as any).agree_terms_of_service) {
      (body as any).agree_terms_of_service = (request as any).agree_terms_of_service;
    }

    if ((request as any).agree_privacy_policy) {
      (body as any).agree_privacy_policy = (request as any).agree_privacy_policy;
    }

    if ((request as any).agree_marketing_information) {
      (body as any).agree_marketing_information = (request as any).agree_marketing_information;
    }

    const response = await fetch(`${API_BASE_URL}/auth/social/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('백엔드 응답 오류:', {
        status: response.status,
        statusText: response.statusText,
        url: response.url,
        body: errorText
      });

      return {
        success: false,
        message: "로그인(또는 사용자등록)에 실패했습니다.",
        ...request,
      };
    }

    const data = await response.json();

    if (data?.status === 'ok' || data?.status === 'success') {
      return {
        success: true,
        ...data
      };
    } else {
      return {
        success: false,
        message: data?.message || "로그인(또는 사용자등록)에 실패했습니다.",
        ...data,
      };
    }
  } catch (error) {
    console.error('백엔드 인증 오류:', error);
    return {
      success: false,
      message: "로그인(또는 사용자등록)에 실패했습니다. 시스템 오류입니다.",
      ...request,
    }
  }
};


//========================================================================================================================
// 백엔드에 사용자 정보 전송
//========================================================================================================================
export const requestToLoginOrRegistration = async (request: UserLoginOrRegistrationRequest, navigate: any): Promise<UserLoginOrRegistrationResponse> => {

  console.log("백엔드에 사용자 정보 전송 요청", request,'/[requestToLoginOrRegistration request------------------------------>]');

  const data = await sendUserToBackend(request);

  console.log("백엔드에 사용자 정보 전송 결과", data,'/[requestToLoginOrRegistration data------------------------------>]');

  localStorage.setItem('kuid', data.id);
        
  if (!data?.agree_terms_of_service || !data?.agree_privacy_policy) {
    navigate('/join',{state:{social_provider:`${request.provider}`, user:data}});
    return data;
  }

  if (!data.phone_number_verified) {
    const url = `/phone-verification?kuid=${data.id}`;
    navigate(url);
    return data;
  }

  return data;
};